// extracted by mini-css-extract-plugin
module.exports = {"root":"mediaPost_root__0oSS1"};